import React from 'react'


export default function BuildElectricity(props) {

    const formatRates =(rates)=>{
        return (parseFloat(rates)).toFixed(3) + ' ¢'
    }

    const renderGPPRows = () => {
        if (props.values.ratesResult.MyQuote) {
         
         let ratesResult = props.values.ratesResult.MyQuote.QuoteBase.map(function(item, i) {
           let rateContent = null;
           let summerRate = null;
           let winterRate = null;
       
           if (item.ContentDesc === 'Fixed Daily Charges') {
               rateContent = formatRates(item.Rate) + '/Day';
           } else {
               if (item.Rate) {
                   rateContent = formatRates(item.Rate) + '/kWh';
               } else {
                   summerRate = formatRates(item.SummerRate);
                   winterRate = formatRates(item.WinterRate);
               }
           }
       
           const contentDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
           return (
                <div className="service-box__toggle--rate-row">
                    <div className="service-box__toggle--rate-label">
                        <label>{item.ContentDesc}{contentDesc}</label>
                    </div>
                    <div className="service-box__toggle--rate-value">{!!rateContent && rateContent}</div>
                </div>
           );
         });
        
         return (
             <>
                 {ratesResult}
             </>
         );
 
        }
    }

    const renderLunchRows = () => {
        if (props.values.lunchRatesResult.MyQuote) {
         
         let ratesResult = props.values.lunchRatesResult.MyQuote.QuoteBase.map(function(item, i) {
           let rateContent = null;
       
           if (item.ContentDesc === 'Fixed Daily Charges') {
               rateContent = formatRates(item.Rate) + '/Day';
           } else {
               if (item.Rate) {
                   rateContent = formatRates(item.Rate) + '/kWh';
               } else {
                 rateContent = '0';
               }
           }
       
           const chargeDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
           const contentDesc = (item.ContentDesc == 'Fixed Daily Charges') && (<span>{item.ContentDesc}</span>);

           return (
                <div className="service-box__toggle--rate-row">
                    <div className="service-box__toggle--rate-label">
                        <label>{contentDesc}{chargeDesc}</label>
                    </div>
                    <div className="service-box__toggle--rate-value">{!!rateContent && rateContent}</div>
                </div>
           );
         });
        
         return (
             <>
                 {ratesResult}
             </>
         );
 
        }
    }

    const renderPowerRows = () => {

        if (props.values.powerRatesResult.MyQuote) {

         let ratesResult = props.values.powerRatesResult.MyQuote.QuoteBase.map(function(item, i) {
           let rateContent = null;
           let summerRate = null;
           let winterRate = null;

           if (item.ContentDesc === 'Fixed Daily Charges') {
               rateContent = formatRates(item.Rate) + '/Day';

               const contentDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
               return (
                    <div className="service-box__toggle--rate-row">
                        <div className="service-box__toggle--rate-label">
                            <label>{item.ContentDesc}{contentDesc}</label>
                        </div>
                        <div className="service-box__toggle--rate-value">{!!rateContent && rateContent}</div>
                    </div>
               );
           } 
         });

         let weekdaysFirstRate = '';
         let weekdaysSecondRate = '';
         let weekdaysThirdtRate = '';
         let weekendFirstRate = '';
         let weekendSecondRate = '';
         let weekendThirdtRate = '';
         props.values.powerRatesResult.MyQuote.QuoteBase.forEach((item, i) => {
                   
             if (item.ChargeDesc === 'Weekdays Peak: 7am-11am & 5pm-9pm') {
                 weekdaysFirstRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekdays Off-Peak: 11am-5pm & 9pm-11pm') {
                weekdaysSecondRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekdays Night: 11pm-7am') {
                weekdaysThirdtRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekends Peak: 7am-11am & 5pm-9pm') {
                weekendFirstRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === "Weekends Off-Peak: 11am-5pm & 9pm-11pm") {
                weekendSecondRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === "Weekends Night: 11pm-7am") {
                weekendThirdtRate = formatRates(item.Rate) + '/kWh';
             }
             
         });
         
         const ratePromise = <>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Weekdays</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    &nbsp;
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Peak: 7am-11am & 5pm-9pm</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekdaysFirstRate}
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Off-Peak: 11am-5pm & 9pm-11pm</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekdaysSecondRate}
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Night: 11pm-7am</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekdaysThirdtRate}
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Weekends</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    &nbsp;
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Peak: 7am-11am & 5pm-9pm</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekendFirstRate}
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Off-Peak: 11am-5pm & 9pm-11pm</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekendSecondRate}
                </div>
            </div>
            <div className="service-box__toggle--rate-row">
                <div className="service-box__toggle--rate-label">
                    <label>Night: 11pm-7am</label>
                </div>
                <div className="service-box__toggle--rate-value">
                    {weekendThirdtRate}
                </div>
            </div>
        </>;
         
         // Combine ratesResult and ratePromise into an array of JSX elements
         return (
             <>
                 {ratesResult}
                 {ratePromise}
             </>
         );
 
        }
    }

    React.useEffect(()=>{
        console.log('selected plan type',props.values.planType);
    },[props.values.planType]);
    
    return (
        <React.Fragment>
           {props.values.planType === "Power Shift Rates" ? (
               <div className="service-box__toggle--rates">
                    {renderPowerRows()}
                </div>
           ) : props.values.planType === "Power Lunch Plan" ? (
            <div className="service-box__toggle--rates">
                {renderLunchRows()}
            </div>
           ) : (
            <div className="service-box__toggle--rates">
                {renderGPPRows()}
                {/* <div className="service-box__toggle--rate-row">
                    <div className="service-box__toggle--rate-label">
                        <label>Price Promise</label>
                    </div>
                    <div className="service-box__toggle--rate-value plan-box__rate-value--green">-2.800 c/kWh</div>
                </div> */}
            </div>
           )}
        </React.Fragment>
      )
  }